import { useQuery } from "@tanstack/react-query";
import api from "apis";

const useDocumentByAdminQuery = (documentUuid?: string) => {
  return useQuery({
    queryKey: api.document.getDocumentByAdminKey(documentUuid!),
    queryFn: () => api.document.getDocumentByAdmin(documentUuid!),
    enabled: !!documentUuid,
    select: (res) => res.data.result.document,
  });
};

export default useDocumentByAdminQuery;
